import style from "./Terms.module.css";

export const Terms = () => {
    return <div>Terms</div>;
};
